<template>
  <div
    class="paged-purchases"
  >
    <purchase-key
      keyTitle="Showing Purchase Types:"
      :statuses="statuses"
    />

    <pagination
      ref="pagination"
      :method="method"
      :formdata="formdata"
      :pageResponse="pageResponse"
      :pageSize="$root.defaultPageSize"
      :preserveHistory="preserveHistory"
      :resourceUrl="resourceUrl"
      orderBy="purchased_at"
      orderType="DESC"
    >
      <template
        slot="paged_item"
        slot-scope="item"
      >
        <router-link
          :class="$root.listItemClasses + ' ' + purchaseClass(item.status)"
          :to="{
            name: 'purchase',
            params: {
              purchaseId: item.id
            }
          }"
        >
          {{ $root.displayDateTimeFmt(item.purchased_at) }}
          {{ item.purchasable_items.map(pi => pi.attributes.name).join(", ") }}
          {{ item.gift ? $root.giftIcon : '' }}
          <span
            v-if="showBuyer"
          >
            ({{ item.customer_email }})
          </span>
        </router-link>
      </template>
    </pagination>
  </div>
</template>
<script>
import Pagination from 'sai-vue-kaminari'

import PurchaseKey from '@/components/PurchaseKey'

export default {
  data () {
    return {
      itemsCount: undefined
    }
  },

  components: {
    'pagination': Pagination,
    'purchase-key': PurchaseKey
  },

  props: {
    'formdata': {
      type: Object,
      default: () => {
        return {
          statuses: []
        }
      }
    },

    'method': {
      type: String,
      default: 'get'
    },

    'pageResponse': {
      type: Object,
      default: () => { return {} }
    },

    'preserveHistory': {
      type: Boolean,
      default: false
    },

    'resourceUrl': {
      type: String,
      default: undefined,
      required: true
    },

    'showBuyer': {
      type: Boolean,
      default: false
    }
  },

  computed: {
    statuses () {
      return this.formdata.statuses || [
        'completed', 'refunded', 'send_confirmation', 'created'
      ]
    }
  },

  methods: {
    onPageSuccess (response) {
      this.$parent.$emit('onPageSuccess', response)
    },

    purchaseClass (status) {
      let className = 'dark'

      switch (status) {
        case 'pending':
          className = 'warning'
          break
        case 'send_confirmation':
          className = 'primary'
          break
        case 'completed':
          className = 'success'
          break
        case 'created':
          className = 'info'
          break
      }

      return 'list-group-item-' + className
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PurchasesPaged.vue